import SecureLS from "secure-ls";
import sendRequest from "./sendRequest";

const checkAuth = async () => {
    try {
        var ls = new SecureLS();
        let data = ls.get('data');
        let authenticated = false;

        if (data) {
            let result = await sendRequest("/api/admin/verifyAuthAdmin", {});
            if (result.type === "success") authenticated = true;
        }
        return authenticated

    } catch (error) {
        return false;
    }
}

export { checkAuth };